import { CFFileForSignatureOnGlass } from './cf-file-for-signature-on-glass';

export class CFSignatureForComplete {
    constructor(
        public fileOnGlass: CFFileForSignatureOnGlass,
        public payload: string
    ) {}
}
